import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  AccountConfiguration,
  AccountOptions,
  SignupAccountConfiguration,
} from '../../models/AccountConfiguration.model';
import { UserTypes } from '../../models/UserTypes.enum';
import { SignupData } from '../../SignupData';
import { accountConfigurations } from '../../data/AccountConfigurations';
import { TranslateModule } from '@ngx-translate/core';
import { DisabledDirective } from '../../../shared/directives/disabled.directive';
import { MatOptionModule } from '@angular/material/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-signup-data',
  templateUrl: './signup-configuration.component.html',
  styleUrls: ['./signup-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    MatOptionModule,
    DisabledDirective,
    TranslateModule,
  ],
})
export class SignupConfigurationComponent {
  configOptionsPrefix = 'SIGNUP.CONFIG_OPTIONS.';

  @Input() signupData: SignupData;

  get data(): SignupAccountConfiguration {
    return this.signupData.configuration;
  }

  get userType(): UserTypes {
    return this.signupData.userType;
  }

  accountConfiguration: AccountConfiguration[] = accountConfigurations;

  isConfigAvailable(config: AccountOptions) {
    try {
      return config.userType.includes(this.userType);
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}
